import { getStoreMenus } from "../../../api/services/storeService";
import { isMenuAvailable } from "../../../api/helpers/datetimeHelper.js";
import { logger } from "./../../../api/Logger.js";
export default {
  state: {
    timer: null,
    updateTime: null,
    storeMenus: [],
    currentMenuId: "DefaultMenu"
  },
  mutations: {
    setCurrentMenuId(state, payload) {
      localStorage.setItem("currentMenuId", payload);
    },
    setTimer(state, payload) {
      state.timer = payload;
    },
    setUpdateTime(state, payload) {
      state.updateTime = payload;
    },
    setStoreMenus(state, payload) {
      state.storeMenus = [];
      state.storeMenus = payload;
    }
  },
  actions: {
    async getStoreMenu(context, payload) {
      getStoreMenus(payload).onSnapshot(
        async function(snapshot) {
          var storeMenus = [];
          snapshot.docs.forEach(function(doc) {
            if (doc.exists) storeMenus.push({ id: doc.id, ...doc.data() });
          });

          context.commit("setStoreMenus", storeMenus);
          context.dispatch("changeMenuState");
        },
        async function(reason) {
          logger.log(
            reason.name,
            reason.toString(),
            "/menu",
            logger.LogType.Error
          );
        }
      );
    },
    changeMenuState(context) {
      if (context.state.timer) window.clearTimeout(context.state.timer);
      context.commit("setUpdateTime", new Date());
      context.commit(
        "setTimer",
        setTimeout(() => {
          context.dispatch("changeMenuState");
        }, 60000 * 5)
      );
    },
    clearStoreMenu(context) {
      context.commit("setCurrentMenuId", "DefaultMenu");
    }
  },
  getters: {
    getProductById: (state, getters) => productId => {
      if (getters.storeMenu) return getters.storeMenu.Products[productId];
      else return null;
    },
    storeMenu(state, getters) {
      let storeMenu = null;
      if (
        state.storeMenus &&
        state.storeMenus.length > 1 &&
        (state.updateTime || !state.updateTime)
      ) {
        storeMenu = state.storeMenus[0];
        if (
          getters.getMenuTimeSettings &&
          getters.getMenuTimeSettings.length > 0
        ) {
          let menuTS = getters.getMenuTimeSettings.find(x =>
            isMenuAvailable(getters.currentStoreDoc, x)
          );
          if (!menuTS) menuTS = state.storeMenus[0];
          storeMenu = state.storeMenus.find(x => x.id == menuTS.MenuType);
          if (!storeMenu) storeMenu = state.storeMenus[0];
        }
      } else if (state.storeMenus && state.storeMenus.length == 1) {
        storeMenu = state.storeMenus[0];
      }
      if (getters.cartItems && getters.cartItems.length > 0) {
        if (
          !storeMenu ||
          storeMenu.id !== localStorage.getItem("currentMenuId")
        ) {
          storeMenu = state.storeMenus.find(
            p => p.id == localStorage.getItem("currentMenuId")
          );
        }
      }
      if (storeMenu) localStorage.setItem("currentMenuId", storeMenu.id);
      return storeMenu;
    }
  }
};
